import { render, staticRenderFns } from "./InsMenuLayout.vue?vue&type=template&id=1cb058ba&scoped=true&"
import script from "./InsMenuLayout.vue?vue&type=script&lang=ts&"
export * from "./InsMenuLayout.vue?vue&type=script&lang=ts&"
import style0 from "./InsMenuLayout.vue?vue&type=style&index=0&lang=less&"
import style1 from "./InsMenuLayout.vue?vue&type=style&index=1&id=1cb058ba&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb058ba",
  null
  
)

export default component.exports